export const LOYALTY_STATUSES = [
    { icon: "🛒", name: "Warung Jagoan", target: 1000000, bonusRate: 0.0025, bonusLabel: "0,25%" },
    { icon: "💪", name: "Warung Andal", target: 2000000, bonusRate: 0.005, bonusLabel: "0,50%" },
    { icon: "⭐", name: "Warung Langganan", target: 3000000, bonusRate: 0.0075, bonusLabel: "0,75%" },
    { icon: "🏪", name: "Warung Favorit", target: 4000000, bonusRate: 0.01, bonusLabel: "1,00%" },
    { icon: "👑", name: "Warung Juara", target: 5000000, bonusRate: 0.0125, bonusLabel: "1,25%" },
];

const numericValue = (value) => {
    if (value == null || value === "") return null;
    const number = Number(value);
    return Number.isFinite(number) && number >= 0 ? number : null;
};

export function readMonthlyTurnover(stats, user) {
    const candidates = [
        stats?.monthlyOmzet,
        stats?.monthly_omzet,
        stats?.omzetBulanan,
        stats?.omzet_bulanan,
        stats?.monthlyRevenue,
        stats?.monthly_revenue,
        stats?.currentMonthOmzet,
        stats?.current_month_omzet,
        stats?.monthly?.omzet,
        stats?.monthly?.revenue,
        user?.monthlyOmzet,
        user?.monthly_omzet,
        user?.omzetBulanan,
        user?.omzet_bulanan,
    ];
    return candidates.map(numericValue).find((value) => value != null) ?? 0;
}

function statusIndex(value) {
    const normalized = String(value || "").trim().toLowerCase();
    return LOYALTY_STATUSES.findIndex((status) => status.name.toLowerCase() === normalized);
}

export function getStatusIndex(monthlyTurnover, storedStatus) {
    const storedIndex = statusIndex(storedStatus);
    if (storedIndex >= 0) return storedIndex;
    const achievedIndex = LOYALTY_STATUSES.reduce(
        (highestIndex, status, index) => (monthlyTurnover >= status.target ? index : highestIndex),
        -1
    );
    return Math.max(0, achievedIndex);
}

export function buildLoyaltySummary(stats, user) {
    const monthlyTurnover = readMonthlyTurnover(stats, user);
    const currentIndex = getStatusIndex(monthlyTurnover, user?.warungStatus || user?.warung_status || stats?.warungStatus || stats?.warung_status);
    const currentStatus = LOYALTY_STATUSES[currentIndex];
    const nextStatus = LOYALTY_STATUSES[currentIndex + 1] || null;
    const progressTarget = nextStatus?.target || currentStatus.target;
    const progress = Math.min(100, Math.round((monthlyTurnover / progressTarget) * 100));
    const bonusRate = currentStatus.bonusRate;

    return {
        monthlyTurnover,
        currentStatus,
        nextStatus,
        progressTarget,
        progress,
        remaining: Math.max(0, progressTarget - monthlyTurnover),
        bonusAmount: Math.round(monthlyTurnover * bonusRate),
        bonusRate,
        noTransactionMonths: numericValue(stats?.noTransactionMonths ?? stats?.no_transaction_months ?? user?.noTransactionMonths) ?? 0,
    };
}

export const formatLoyaltyRate = (rate) => `${(rate * 100).toFixed(2).replace(".", ",")} %`;
